/* eslint-disable max-len */
import { OV_CDN } from '../../config/theme'; // cloud constants

export var SUBMIT_URL = 'https://doers.ov.app'; // text constants

export var FORM_TITLE = 'We’re glad you’re here';
export var FORM_SUBTITLE = 'Complete this application for the chance to join our <br />Doing Things Network.';
export var SUCCESS_TITLE = 'Thank you!';
export var SUCESS_SUBTITLE = 'Thanks for applying to the Doing Things Network! We’ll review your application soon. A member of Team OV will reach out if we’re currently recruiting and would like to proceed.';
export var DOB_LABEL = 'Date of Birth';
export var OPT_IN_LABEL = 'Yes, I would like to receive emails from Outdoor Voices with exclusive gifts and offers.';
export var OF_AGE_LABEL = 'Are you over the age of 18?';
export var UNDERGRAD_LABEL = 'Are you currently enrolled in an undergraduate college program?';
export var INFLUENCER_PLATFORMS_LABEL = 'Are you currently enrolled on any influencer affiliate platforms? (Please select all that apply)';
export var INFLUENCER_PLATFORMS = [{
  checked: false,
  label: 'RewardStyle'
}, {
  checked: false,
  label: 'ShopStyle'
}, {
  checked: false,
  label: 'Skims'
}, {
  checked: false,
  label: 'MagicLinks'
}, {
  checked: false,
  label: 'Vigilink'
}, {
  checked: false,
  label: 'Other'
}];
export var FAV_COPY = 'Favorite Recreational Activities';
export var WHY_COPY = 'Why do you want to be an OV ambassador and help spread our mission?';
export var referrerOptions = [{
  label: 'OV Doer/Ambassador',
  value: '0'
}, {
  label: 'Team OV Employee',
  value: '1'
}, {
  label: 'OV Website',
  value: '2'
}, {
  label: 'Friend/Family',
  value: '3'
}, {
  label: 'Other',
  value: '4'
}];
export var states = [{
  label: 'Alabama',
  value: 'AL'
}, {
  label: 'Alaska',
  value: 'AK'
}, {
  label: 'American Samoa',
  value: 'AS'
}, {
  label: 'Arizona',
  value: 'AZ'
}, {
  label: 'Arkansas',
  value: 'AR'
}, {
  label: 'California',
  value: 'CA'
}, {
  label: 'Colorado',
  value: 'CO'
}, {
  label: 'Connecticut',
  value: 'CT'
}, {
  label: 'Delaware',
  value: 'DE'
}, {
  label: 'District Of Columbia',
  value: 'DC'
}, {
  label: 'Federated States Of Micronesia',
  value: 'FM'
}, {
  label: 'Florida',
  value: 'FL'
}, {
  label: 'Georgia',
  value: 'GA'
}, {
  label: 'Guam Gu',
  value: 'GU'
}, {
  label: 'Hawaii',
  value: 'HI'
}, {
  label: 'Idaho',
  value: 'ID'
}, {
  label: 'Illinois',
  value: 'IL'
}, {
  label: 'Indiana',
  value: 'IN'
}, {
  label: 'Iowa',
  value: 'IA'
}, {
  label: 'Kansas',
  value: 'KS'
}, {
  label: 'Kentucky',
  value: 'KY'
}, {
  label: 'Louisiana',
  value: 'LA'
}, {
  label: 'Maine',
  value: 'ME'
}, {
  label: 'Marshall Islands',
  value: 'MH'
}, {
  label: 'Maryland',
  value: 'MD'
}, {
  label: 'Massachusetts',
  value: 'MA'
}, {
  label: 'Michigan',
  value: 'MI'
}, {
  label: 'Minnesota',
  value: 'MN'
}, {
  label: 'Mississippi',
  value: 'MS'
}, {
  label: 'Missouri',
  value: 'MO'
}, {
  label: 'Montana',
  value: 'MT'
}, {
  label: 'Nebraska',
  value: 'NE'
}, {
  label: 'Nevada',
  value: 'NV'
}, {
  label: 'New Hampshire',
  value: 'NH'
}, {
  label: 'New Jersey',
  value: 'NJ'
}, {
  label: 'New Mexico',
  value: 'NM'
}, {
  label: 'New York',
  value: 'NY'
}, {
  label: 'North Carolina',
  value: 'NC'
}, {
  label: 'North Dakota',
  value: 'ND'
}, {
  label: 'Northern Mariana Islands',
  value: 'MP'
}, {
  label: 'Ohio',
  value: 'OH'
}, {
  label: 'Oklahoma',
  value: 'OK'
}, {
  label: 'Oregon',
  value: 'OR'
}, {
  label: 'Palau',
  value: 'PW'
}, {
  label: 'Pennsylvania',
  value: 'PA'
}, {
  label: 'Puerto Rico',
  value: 'PR'
}, {
  label: 'Rhode Island',
  value: 'RI'
}, {
  label: 'South Carolina',
  value: 'SC'
}, {
  label: 'South Dakota',
  value: 'SD'
}, {
  label: 'Tennessee',
  value: 'TN'
}, {
  label: 'Texas',
  value: 'TX'
}, {
  label: 'Utah',
  value: 'UT'
}, {
  label: 'Vermont',
  value: 'VT'
}, {
  label: 'Virgin Islands',
  value: 'VI'
}, {
  label: 'Virginia',
  value: 'VA'
}, {
  label: 'Washington',
  value: 'WA'
}, {
  label: 'West Virginia',
  value: 'WV'
}, {
  label: 'Wisconsin',
  value: 'WI'
}, {
  label: 'Wyoming',
  value: 'WY'
}];
var imageRoot = "".concat(OV_CDN, "shopify/2.0.0/images/pages/ambassador/");
var hero = {
  cta: 'Learn More',
  imageDesktop: {
    alt: 'Group of friends dog walking togther, wearing OV Nimbus Cotton outfits',
    src: "".concat(imageRoot, "hero_desktop.jpg")
  },
  imageMobile: {
    alt: 'Group of friends dog walking togther, wearing OV Nimbus Cotton outfits',
    src: "".concat(imageRoot, "hero_mobile.jpg")
  },
  message: 'Welcome to the Doing Things Network — a community of OV ambassadors who love Doing Things in good company. Apply to join us today.',
  title: 'Hey, Hi, Hello!'
};
var joinTeam = {
  cta: 'Apply Now',
  image: {
    alt: 'Doers doing things.',
    src: "".concat(imageRoot, "join_team.png")
  },
  message: 'The Doing Things Network is a diverse community of OV ambassadors who are passionate about living a Recreation-driven lifestyle. Doers are an extension of Team OV and represent our brand through mission building, social promotion, and community engagement.',
  statement: 'We’re on a mission <br> to get the world moving.',
  title: 'Join the Team'
};
var doerBlockFirst = {
  cta: 'Apply Now',
  image: {
    alt: 'Man wearing OV holds sports goal and stares at the camera with unimpressed look.',
    src: "".concat(imageRoot, "doer_block_1.jpg")
  },
  isImageLeft: false,
  key: 'xplain-block',
  message: 'Doers are active, action-oriented, and go the extra mile — on and off the trails. They believe Recreation is a mindset as much as it is a lifestyle, and approach activity with ease, humor, and delight. Doers are thought leaders, Recreation enthusiasts, and community builders.',
  title: 'Our Doers'
};
var doerBlockSecond = {
  cta: 'Apply Now',
  image: {
    alt: 'Woman wearing OV uses binoculars to spy something in the distance.',
    src: "".concat(imageRoot, "doer_block_2.jpg")
  },
  isImageLeft: true,
  key: 'perks-block',
  message: 'Our Doing Things Network gets the inside scoop on all things Outdoor Voices, including first looks at product launches, exclusive discounts, and access to Team OV. Plus, earn rewards when you inspire others to get moving.',
  title: 'The Perks'
};
var doerBlocks = [doerBlockFirst, doerBlockSecond];
var blurbToAction = {
  blurb: 'Join us in getting the world moving <br>and #DoingThings.',
  cta: 'Apply Now'
};
export var props = {
  hero: hero,
  joinTeam: joinTeam,
  doerBlocks: doerBlocks,
  blurbToAction: blurbToAction
};